export default {
  showBar(state) {
    return state.showBar;
  },
  ofertas(state) {
    return state.ofertas;
  },
  oferta: state => id => state.ofertas.find(oferta => oferta.id === id),
};
